import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Ticker } from "../../_app/types";

export interface SharedData {
  tickers: Ticker[];
}

// Начальное состояние
const initialState: SharedData = {
  tickers: [],
};

const sharedSlice = createSlice({
  name: "shared",
  initialState,
  reducers: {
    setTickers: (state, action: PayloadAction<Ticker[]>) => {
      state.tickers = action.payload;
    },
  },
});

// Экспортируем экшены
export const { setTickers } = sharedSlice.actions;

// Экспортируем редьюсер
export default sharedSlice.reducer;
